const { debounce } = window.BAO.Utils

class FilterFacetSearch extends window.BAO.CustomElement({
  SuperClass: HTMLInputElement,
}) {
  connectedCallback () {
    super.connectedCallback()
    this.setupListeners()
  }

  setupListeners () {
    super.setupListeners()
    this.debouncedOnSearchInput = debounce(
      event => this.onSearchInput(event),
      250,
    )

    this.addEventListener('input', this.debouncedOnSearchInput)
  }

  onSearchInput (event) {
    const parent = this.closest('[data-filter-facet-search-external-el="body"]')
    const items = parent.querySelectorAll(
      '[data-filter-facet-search-external-el="item"]',
    )

    items.forEach(item => {
      const label = item.querySelector('label')
      const labelText = label.textContent.toLowerCase()
      const searchValue = this.value.toLowerCase()

      if (labelText.includes(searchValue)) {
        item.setAttribute('aria-hidden', 'false')
      } else {
        item.setAttribute('aria-hidden', 'true')
      }
    })
  }
}

window.customElements.define('filter-facet-search', FilterFacetSearch, {
  extends: 'input',
})
